export const codeListsConfig = [
	{
		uri: "/cl/Entity.CL.Address.Region",
		name: "region"
	},
	{
		uri: "/cl/Entity.CL.Country",
		name: "country"
	},
	{
		uri: "/cl/Entity.CL.AddressType",
		name: "addressType"
	},
	{
		uri: "/cl/Entity.CL.LegalForm",
		name: "legalForm"
	},
	{
		uri: "/cl/Entity.CL.CompanyType",
		name: "companyType"
	},
	{
		uri: "/cl/GD.CL.Entity.SK.NACE",
		name: "skNace"
	},
	{
		uri: "/cl/GD.CL.Data.RegionType",
		name: "regionType"
	},
	{
		uri: "/cl/GD.CL.Device",
		name: "device"
	},
	{
		uri: "/cl/GD.CL.Entity.CompanySize",
		name: "companySize"
	},
	{
		uri: "/cl/GD.CL.Data.DeviceGroup",
		name: "deviceGroup"
	},
	{
		uri: "/cl/GD.CL.Request.Status",
		name: "requestStatus"
	}
]

